import React, { useEffect, useState } from 'react';
import Loader from '../loading/Loader';
import AnimatedHeader from '../animatedLetters/AnimatedHeader';
import { ContactSection } from './contactStyle';
import Lottie from 'react-lottie';
import spaceAnimation from '../../assets/animations/space.json';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [spinner, setSpinner] = useState(true);

  useEffect(() => {
    if (!spinner) {
      setSpinner(false);
    }
    // eslint-disable-next-line
  }, [spinner]);

  const loadTime = (loader) => {
    setSpinner(loader);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: '',
    });
  };

  const handleChange = (e) => {
    e.preventDefault();
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const { name, email, subject, message } = formData;

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: spaceAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <>
      {spinner ? (
        <Loader loadTime={loadTime} />
      ) : (
        <ContactSection>
          <div className='text-zone'>
            <h1>
              <AnimatedHeader
                letterClass={'text-animate-hover'}
                strArray={['C', 'o', 'n', 't', 'a', 'c', 't', ' ', 'm', 'e']}
                idx={30}
              />
            </h1>
            <p>
              I am interested in freelance opportunities especially ambitious or
              large projects. However, if you have other request or question,
              don't hesitate to contact me using the form below.
            </p>
            <div className='contact-form'>
              <form onSubmit={handleSubmit}>
                <ul>
                  <li className='half'>
                    <input
                      type='text'
                      name='name'
                      placeholder='Name'
                      required
                      value={name}
                      onChange={handleChange}
                    />
                  </li>
                  <li className='half'>
                    <input
                      type='text'
                      name='email'
                      placeholder='Email'
                      required
                      value={email}
                      onChange={handleChange}
                    />
                  </li>
                  <li>
                    <input
                      type='text'
                      name='subject'
                      placeholder='Subject'
                      required
                      value={subject}
                      onChange={handleChange}
                    />
                  </li>
                  <li>
                    <textarea
                      placeholder='message'
                      name='message'
                      required
                      value={message}
                      onChange={handleChange}
                    ></textarea>
                  </li>
                  <li>
                    <input
                      type='submit'
                      value='SEND'
                      className='flat-button'
                      onClick={handleSubmit}
                    />
                  </li>
                </ul>
              </form>
            </div>
          </div>
          <div className='img-zone'>
            <Lottie options={defaultOptions} />
          </div>
        </ContactSection>
      )}
    </>
  );
};

export default Contact;
